// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PTimeOutOutlinedSvg from "@fishx/icons-svg/es/asn/PTimeOutOutlined";
import FishxIcon from '../components/FishxIcon';

var PTimeOutOutlined = function PTimeOutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PTimeOutOutlinedSvg
  }));
};

PTimeOutOutlined.displayName = 'PTimeOutOutlined';
export default React.forwardRef(PTimeOutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PTimeOutOutlined.js
// module id = 3685
// module chunks = 0